// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Banks from "./components/Banks";
import Stats from "./components/Stats";
import AwardsGallery from "./components/AwardsGallery";
import CTA from "./components/CTA";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollReveal from "./components/ScrollReveal";
import Team from "./components/Team";
import useSiteContent from "./hooks/useSiteContent";

function Home({ content }) {
  return (
    <>
      <Hero />
      <ScrollReveal><Services /></ScrollReveal>
      <ScrollReveal delay={0.05}><Banks partners={content.partners} /></ScrollReveal>
      <ScrollReveal delay={0.08}><Stats /></ScrollReveal>
      <ScrollReveal delay={0.1}><AwardsGallery photos={content.photos} /></ScrollReveal>
      <ScrollReveal delay={0.12}><CTA /></ScrollReveal>
    </>
  );
}

export default function App() {
  const content = useSiteContent();

  return (
    <Router>
      <Header />

      <main>
        <Routes>
          <Route path="/" element={<Home content={content} />} />
          <Route path="/about" element={<ScrollReveal><About /></ScrollReveal>} />
          <Route path="/team" element={<ScrollReveal><Team members={content.team} /></ScrollReveal>} />
          <Route path="/contact" element={<ScrollReveal><Contact /></ScrollReveal>} />

          {/* fallback to home for unknown routes */}
          <Route path="*" element={<Home content={content} />} />
        </Routes>
      </main>

      <Footer />
    </Router>
  );
}
